import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../../utils/Constants';

export const getNannyProfileStatus = createAsyncThunk('getNannyProfileStatus', async () => {
    const token = localStorage.getItem('Token');
    const headers = {
        Authorization: token,
        'Content-Type': 'application/json',
    };
    const response = await axios.get(`${BASE_URL}/v1/nanny/profile/status`, { headers });
    return response.data;
});

const NannyProfileStatusSlice = createSlice({
    name: 'nannyProfileStatus',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {
        clearProfileStatus: (state) => { state.data = null; },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getNannyProfileStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getNannyProfileStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(getNannyProfileStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { clearProfileStatus } = NannyProfileStatusSlice.actions;
export default NannyProfileStatusSlice.reducer;
